import { ptColors } from "@/config/colors";

export const initialEditorState = {
  isMap: true,
  enabled: true,
  modelId: null,
  mode: "create",
  id: "",
  geom_type: "",
  geometry: "",
  history: [],
  historyIndex: 0,
  activeLayers: [],
  modelLayers: [],
  name: "",
  isDrawing: false,
  loading: false,
  // deleting objects helpers
  deletingCallback: null,
  deletingIds: [],
  dependenciesCount: 0,
  // creating object helpers
  withAttributes: false,
  objectFields: [],
  creatingCallback: null,
  activeObject: null,
  centerGeom: null,
  editingCallback: null,
  // dependencies map helpers
  dependenciesData: {},
  deletedDependenciesIds: []
};

export const publicTransportLayersConfig = {
  nodes: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": 3,
      "circle-color": ptColors.baseColor,
      "circle-pitch-alignment": "map"
    }
  },
  links: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": ptColors.baseColor,
      "line-width": 1
    }
  },
  stop_points: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.4,
        stops: [[6, 2], [22, 10]]
      },
      "circle-color": ptColors.white,
      "circle-pitch-alignment": "map",
      "circle-stroke-color": ptColors.routeColor,
      "circle-stroke-width": {
        base: 1,
        stops: [[6, 1], [22, 2]]
      }
    }
  },
  line_routes: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": ptColors.routeColor,
      "line-width": 4
    }
  }
};
